export default __webpack_public_path__ + "static/PPEditorialNew-LightItalic-2d6699edafb7f8263590d2fe40c758cb.woff";